
<div [ngClass]="{'card-face': true, 'is-flipped': isFlipped}">
<div [ngClass]="{'grid-content': true, 'hasBackground': reportObject.HasBackground }" *ngIf="reportObject" 
[ngStyle]="{'padding': reportObject.PaddingValue ? reportObject.PaddingValue : '0px', 'background-color': reportObject.HasBackground ? reportObject.BackgroundColor : 'transparent',
'border-radius': reportObject.BorderRadiusValue ? reportObject.BorderRadiusValue : '0px', 'box-shadow': reportObject.BoxShadowValue }"
[id]="groupName + '_' + reportObject.TemplateType">

  <div *ngIf="reportObject.TemplateType == 'DocumentSummary' || reportObject.TemplateType == 'ViewList' || reportObject.TemplateType == 'Outline'" class="toggle-panel-container" 
  [class.first]="reportObject.TemplateType == 'QuickLinks'"
  [class.white]="reportObject.TemplateType == 'DocumentSummary'" [class.hide]="reportObject.IsCollapsed" (click)="togglePanel()">
    <fa *ngIf="!reportObject.IsCollapsed" class="angle-double-left" name="angle-double-left" title="Hide"></fa>
    <fa *ngIf="reportObject.IsCollapsed" class="angle-double-right" name="angle-double-right" title="Show"></fa>
  </div>

  <p *ngIf="reportObject.HeaderTitle && reportObject.TemplateType != 'PopupButton'" class="{{reportObject.HeaderTitleType.toUpperCase()}} text" [class.hide]="reportObject.IsCollapsed">{{reportObject.HeaderTitle}}</p>
  <p *ngIf="reportObject.HeaderValue && reportObject.TemplateType != 'PopupButton'" class="{{reportObject.HeaderValueType.toUpperCase()}} text" [class.hide]="reportObject.IsCollapsed">{{reportObject.HeaderValue}}</p>

  <span *ngIf="reportObject.HasMenu" class="utter-icon" (click)="onContextMenu($event)" title="View options"><i class="fa fa-ellipsis-v"></i></span>
  <context-menu *ngIf="reportObject.HasMenu" [useBootstrap4]="true">
    <ng-template contextMenuItem (execute)="pullPopupTag(reportObject)">
      Add Tag
    </ng-template>
    <ng-template contextMenuItem (execute)="pullPopupUtterance(reportObject)">
      Add Quick Phrase
    </ng-template>
    <ng-container *ngIf="dialog">
      <ng-template contextMenuItem (execute)="getRelatedEpics(reportGroup)">
        Get Related Reports
      </ng-template>
    </ng-container>
    <ng-template contextMenuItem (execute)="addMetadata(reportObject)">
      Add Metadata
    </ng-template>
  </context-menu>
  <a *ngIf="reportObject.HasMenu && reportObject.Metadata.length > 0" class="flipper-box" 
    [mdePopoverTriggerFor]="appPopover" 
    mdePopoverTriggerOn="click" 
    #popoverTrigger="mdePopoverTrigger" 
    [mdePopoverBackdropCloseOnClick]="true"
    title="Further Insights" (click)="popover(popoverTrigger)">
    <span class="flip-label">{{isFlipped ? 'Back' : 'Further Insights'}}</span>
    <a [ngClass]="{'flipper-icon': true, 'toggle' : isFlipped}"></a>
  </a>

  <ng-container *ngIf="reportObject.HasContent">
    <ng-container [ngSwitch]="reportObject.TemplateType">
      <ng-container *ngSwitchCase="'WebContent'">
        <ng-container *ngIf="!webContentComponentId">
          <iframe width="100%" [src]="reportObject.Content | safe" [ngStyle]="{'border':'none', 'height': 'calc(100% - ' + reportObject.FilledSpace + 'rem)'}" allowfullscreen="true"></iframe>
        </ng-container>
        <!-- <img src="https://www.gettyimages.com/gi-resources/images/CreativeLandingPage/HP_Sept_24_2018/CR3_GettyImages-159018836.jpg"
        [ngStyle]="{'height': 'calc(100% - ' + reportObject.FilledSpace + 'rem)'}"> -->
        <!-- <a (click)="openPopup(reportObject.Content)" class="magnify"><mat-icon>fullscreen</mat-icon></a> -->
        <ng-container *ngIf="webContentComponentId">
          <app-web-content [setComponentId]="variables[webContentComponentId]"></app-web-content>
        </ng-container>
        
      </ng-container>
      <ng-container *ngSwitchCase="'DocumentSummary'">
        <div [ngClass]="{'docSummaryPanel custom-scrollbar' : true}" [class.hide]="reportObject.IsCollapsed" 
        [ngStyle]="{'height': reportObject.FilledSpace == 1 || reportObject.FilledSpace == 0 ? '100%' : 'calc(100% - ' + reportObject.FilledSpace + 'rem)'}">
          <app-summary 
          [componentId]="variables[summaryComponentId]" 
          [keyword]="variables[summarySearchKeyword]" 
          [customInput]="variables[summaryInputChange]"
          (keywordChanged)="SetVariableValue(searchKeywordChanged,$event)"
          (selectedId)="SetVariableValue(summarySelectedId,$event)"
          (setSummaryName)="SetVariableValue(summaryNameChange,$event)"
          [hidePanel]="reportObject.IsCollapsed"
          [inputComboFilter]="inputComboFilter"></app-summary>
        <div class="super-line"></div>
        </div>
      </ng-container>
      <ng-container *ngSwitchCase="'DocumentSubSummary'">
        <app-sub-summary [componentIdSet]="variables[summaryComponentId]" (subSelectedId)="SetVariableValue(subSummarySelectedId,$event)" [filledSpace]="reportObject.FilledSpace"></app-sub-summary>
      </ng-container>
      <ng-container *ngSwitchCase="'DocumentDetail'">
        <div [ngClass]="{'docDetailPanel open custom-scrollbar': true, 'full': fullDetail, 'free-layout': !isFixHeight }" 
        [ngStyle]="{'height': reportObject.FilledSpace > 1 ? 'calc(100% - ' + reportObject.FilledSpace + 'rem)' : '100%',
            'border-radius': reportObject.BorderRadiusValue ? reportObject.BorderRadiusValue : '0px'}">
          <app-detail [setComponentId]="variables[detailComponentId]" (subSelectedId)="SetVariableValue(subSummarySelectId,$event)" 
          (propertyValueChanged)="SetVariableValue(propertyValueChanged,$event)"
          (emitProperty)="SetVariableValue(emitValueChanged,$event)"></app-detail>
        </div>
      </ng-container>
      <ng-container *ngSwitchCase="'VerticalProgress'">
        <app-progress-stepper [setDocumentList]="reportObject.Content" [borderRadius]="reportObject.BorderRadiusValue" [progressChanged]="variables[progressChanged]"></app-progress-stepper>
      </ng-container>
      <ng-container *ngSwitchCase="'SearchBar'">
        <app-searchbar [setPlaceholder]="variables[searchPlaceholder]" [keyword]="variables[searchKeyword] ? variables[searchKeyword] : ''" (keywordChanged)="SetVariableValue(searchKeywordChanged, $event)" [isCard]="'True'" [enableSearch]="true"></app-searchbar>
      </ng-container>
      <ng-container *ngSwitchCase="'InputBar'">
        <app-inputbar [setComponentId]="variables[inputComponentId]" (idOutput)="SetVariableValue(inputValueChanged, $event)" [isCard]="'True'"></app-inputbar>
      </ng-container>
      <ng-container *ngSwitchCase="'QuickLinks'">
        <app-quick-links-panel [isEpic]="true" [hidePanel]="reportObject.IsCollapsed"></app-quick-links-panel>
      </ng-container>
      <div *ngSwitchCase="'JobList'" class="joblist-main-container" [ngStyle]="{'height': 'calc(100% - ' + reportObject.FilledSpace + 'rem)'}">
        <app-joblist [jobListType]="'dashboard'"></app-joblist>
      </div>
      <ng-container *ngSwitchCase="'ViewList'">
        <app-view (viewSelectedChanged)="SetVariableValue(viewChangedId, $event)" [setComponentId]="variables[viewListId]" [notFixedWidth]="trueVar" [hidePanel]="reportObject.IsCollapsed" [groupType]="groupTypeInView"></app-view>
      </ng-container>
      <ng-container *ngSwitchCase="'Menu'">
        <app-view (menuSelectedChanged)="SetVariableValue(menuComponentIdChanged, $event)" [notFixedWidth]="trueVar" [setMenuId]="variables[menuComponentId]"></app-view>
      </ng-container>
      <ng-container *ngSwitchCase="'Welcome'">
        <app-welcome ></app-welcome>
        <!-- <app-khamis (searchResultId)="SetVariableValue(khamisSearchResultId, $event)" (searchChanged)="SetVariableValue(khamisSearchChanged, $event)"></app-khamis> -->
      </ng-container>
      <ng-container *ngSwitchCase="'KHAMISSearch'">
        <app-khamis (searchResultId)="SetVariableValue(khamisSearchResultId, $event)" 
        (searchChanged)="SetVariableValue(khamisSearchChanged, $event)"
        [searchType]="khamisSearchType"></app-khamis>
      </ng-container>
      <ng-container *ngSwitchCase="'SearchResult'">
        <app-khamis-dialog [searchResultId]="variables[searchResultId]" [searchResultChanged]="variables[searchResultChanged]" [reportGroupWidth]="reportGroupWidth" [pageContent]="pageContent"></app-khamis-dialog>
      </ng-container>
      <div *ngSwitchCase="'AttentionItems'" class="pending-item-main-container" [ngStyle]="{'height': 'calc(100% - ' + reportObject.FilledSpace + 'rem)'}">
        <app-pendingitem [filledSpace]="reportObject.FilledSpace"></app-pendingitem>
      </div>
      <ng-container *ngSwitchCase="'ImageLink'">
        <app-logo></app-logo>
      </ng-container>
      <ng-container *ngSwitchCase="'PrimaryMenu'">
        <app-primary-menu></app-primary-menu>
      </ng-container>
      <ng-container *ngSwitchCase="'Label'">
        <app-label [content]="reportObject.Content"></app-label>
      </ng-container>
      <ng-container *ngSwitchCase="'InputCombo'">
        <app-input-combo [setComboId]="variables[filterComboId]" (selectedComboIdChanged)="SetVariableValue(filterComboChanged, $event)"></app-input-combo>
      </ng-container>
      <ng-container *ngSwitchCase="'Outline'">
        <!-- variables[outlineComponentId] is empty -->
        <div class="treeview-container custom-scrollbar">
          <div class="treeview" style="width: 100%; padding-left: 0.7rem;">
            <!-- <p class="view-title" (click)="hideOutline = !hideOutline">Document Outline<span [class.hide]="hideOutline"></span></p> -->
            <div [ngClass]="{'tree-container': true, 'hide': hideOutline}">
              <app-document-outline [setComponentId]="variables[outlineComponentId]" (selectedItem)="SetVariableValue(outlineSelectedId,$event)"></app-document-outline>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-container *ngSwitchCase="'Charts'">
        <div [ngStyle]="{'height': 'calc(100% - ' + reportObject.FilledSpace + 'rem)'}">
          <app-chart [filledSpace]="reportObject.FilledSpace" 
          [setComponentId]="variables[chartComponentId]"
          [setChartLoading]="triggerChartLoading"></app-chart>
        </div>
      </ng-container>
      <ng-container *ngSwitchCase="'KeyIndicator'">
        <app-key-indicator [setComponentId]="variables[keyIndicatorComponentId]"></app-key-indicator>
      </ng-container>
      <ng-container *ngSwitchCase="'PopupButton'">
        <app-broadcast [detailId]="variables[popupButtonId]"
        [title]="reportObject.HeaderTitle"
        [broadcastAction]="broadcastAction" 
        [docType]="broadcastDocType" 
        [docId]="broadcastDocId" 
        [type]="broadcastType"
        [color]="broadcastColor"></app-broadcast>
      </ng-container>
    </ng-container>
  </ng-container>
  <div style="order:3">
      <p *ngIf="reportObject.HasSubFooterTitle" class="{{reportObject.SubFooterTitleType.toUpperCase()}} text sub-footer">{{reportObject.SubFooterTitle}}</p>
      <p *ngIf="reportObject.HasFooterTitle" class="{{reportObject.FooterTitleType.toUpperCase()}} text">{{reportObject.FooterTitle}}</p>
      <p *ngIf="reportObject.HasSubFooterValue" class="{{reportObject.SubFooterValueType.toUpperCase()}} text sub-footer-value">{{reportObject.SubFooterValue}}</p>
      <p *ngIf="reportObject.HasFooterValue" class="{{reportObject.FooterValueType.toUpperCase()}} text">{{reportObject.FooterValue}}</p>
    </div>
</div>

<!-- material tooltip -->
<mde-popover #appPopover="mdePopover" 
  [mdePopoverOverlapTrigger]="false" 
  [mdePopoverOffsetX]="position == 'left' ? 14 : -14" 
  [mdePopoverCloseOnClick]="false" 
  [mdeFocusTrapEnabled]="true"
  (close)="popoverClose()"
  class="secondary-popover">
  <div #mdePopover class="mde-popover-container popover-metadata">
    <div *ngFor="let data of metadataObject" class="meta-sub-item">
      <div style="padding: 15px;">
        <p class="metadata-header"><span>{{data.Type}}</span></p>
        <div class="metadata-sub-container">
          <div *ngFor="let metadata of data.Metadata" class="metadata-parent">
            <div class="row">
              <p class="col-md-2 metadata-title" [innerHTML]="metadata.MetadataName"></p>
              <p class="col-md-10 metadata-content" [innerHTML]="metadata.MetadataValue | safe_html"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</mde-popover>



<div *ngIf="reportObject.Metadata.length > 0" class="flipper-back">
  <div [ngClass]="{'flipper-back-content': true }" 
  [ngStyle]="{'padding': reportObject.PaddingValue ? reportObject.PaddingValue : '0px', 'background-color': reportObject.HasBackground ? reportObject.BackgroundColor : 'transparent', 
  'border-radius': reportObject.BorderRadiusValue ? reportObject.BorderRadiusValue : '0px', 'box-shadow': reportObject.BoxShadowValue }">
    <a *ngIf="reportObject.HasMenu" class="flipper-box" (click)="isFlipped = !isFlipped" title="Show more">
      <span class="flip-label">{{isFlipped ? 'Back' : 'Show More'}}</span>
      <a [ngClass]="{'flipper-icon': true, 'toggle' : isFlipped}"></a>
    </a>
    <div *ngFor="let data of metadataObject" class="meta-sub-item">
      <div style="padding: 15px;">
        <p class="metadata-header"><span>{{data.Type}}</span></p>
        <div class="metadata-sub-container">
          <div *ngFor="let metadata of data.Metadata" class="metadata-parent">
            <div class="row">
              <p class="col-md-4 metadata-title" [innerHTML]="metadata.MetadataName"></p>
              <p class="col-md-8 metadata-content" [innerHTML]="metadata.MetadataValue"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
</div>